import api from '@api/endpoints';
import { WORKFLOW as types } from '@store/constants';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';

export const searchUserDocs =
  ({
    userId,
    searchReq,
    fromStore = true,
    onSuccess,
    onComplete
  }) =>
  async (dispatch) => {
    try {
      fromStore &&
        dispatch({
          type: types.GETTING_USER_DOCS
        });
      const { data } = await api.workflow.userDocsV2({
        userId,
        searchReq
      });

      fromStore &&
        dispatch({
          type: types.GET_USER_DOCS_SUCCESS,
          payload: data
        });
      !fromStore && onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: 'Something went wrong while fetching user docs!',
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      fromStore &&
        dispatch({
          type: types.GET_USER_DOCS_FAILURE,
          payload: error
        });
    } finally {
      onComplete && onComplete();
    }
  };

export const clearUserDocs = () => ({
  type: types.CLEAR_USER_DOCS
});

export const getWorkflowScreensData =
  ({ workflowId, userId }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: types.GETTING_WORKFLOW_SCREENS_DATA,
        payload: {
          workflowId
        }
      });

      const { data } = await api.workflow.getWorkflowScreenData({
        userId,
        workflowId
      });

      return dispatch({
        type: types.GET_WORKFLOW_SCREENS_DATA_SUCCESS,
        payload: {
          workflowId,
          data
        }
      });
    } catch (error) {
      dispatch({
        type: types.GET_WORKFLOW_SCREENS_DATA_FAILURE,
        payload: {
          workflowId,
          data: error
        }
      });
    }
  };

  export const handleViewDocClick = (link) => async (dispatch) => {
    try {
      const { data } = await api.workflow.docByDocUrl({ docUrl: link });
      window.open(data.url);
    } catch (err) {
      console.error(err?.message);
      dispatch(
        setAlert({
          title: 'Something went wrong while fetching the document!',
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
    }
  };
